/* eslint-disable max-len */
import React, { useState } from 'react'
export default function AdvancedSearchInputBox({
    label,
    placeholder,
    htmlFor,
    id,
    value,
    handleOnChangeInput,
    data_testid,
    disabled,
    maxLength,
}) {
    return (
        <div className='flex flex-col'>
            {label !== "" && <label htmlFor={htmlFor} className='text-xs font-normal text-[#000000] mb-1 more-lines' title={label}>{label}</label>}
            <div className='relative'>
                <input
                    maxLength={maxLength}
                    data-testid={data_testid}
                    type="text"
                    id={id}
                    
                    onInput={(e) => {
                        if (id === "serial_number") {
                            // Replace non-numeric characters with an empty string
                            e.target.value = e.target.value.replace(/[^0-9a-zA-Z]/g, '');
                        }
                    }}
                    onWheel={e => e.target.blur()}
                    autoComplete="off"
                    value={value}
                    disabled={disabled}
                    onChange={(e) => {  
                        handleOnChangeInput(id, e.target.value)
                    }}
                    className={`border border-[#C5C9DA] rounded-lg px-2 py-1.5 text-sm font-normal 
                text-[#000000] w-full disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-xs outline-none appearance-none`} placeholder={placeholder} />
            </div>
        </div>
    )
}
